// 특정 role 보유자만 진입할 수 있는 라우트 가드.
// 09 §6.10 RBAC — 라우트 가드는 UX 차원의 가드. 보안은 Firestore Rules 에서.

import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import Loader from 'components/Loader';
import { useAuth, type UserRole } from 'contexts/AuthContext';

interface RequireRoleProps {
  role: UserRole;
  children: ReactNode;
}

export default function RequireRole({ role, children }: RequireRoleProps) {
  const { user, loading, isFirebaseConfigured, hasRole } = useAuth();
  const location = useLocation();

  if (loading) return <Loader />;
  if (!isFirebaseConfigured) return <>{children}</>;
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!hasRole(role)) {
    return (
      <Stack spacing={2} sx={{ p: 3 }}>
        <Alert severity="warning">
          이 화면에 접근할 권한이 없습니다. ({role} 권한 필요)
        </Alert>
        <Box>
          <Button variant="outlined" onClick={() => window.history.back()}>
            뒤로
          </Button>
        </Box>
      </Stack>
    );
  }
  return <>{children}</>;
}
